import { useUpdateTerminKalenderForm } from '@/domain/termine/features/UpdateTerminkalender/shared/hooks';
import { createContext, useContext } from 'react';
type UpdateTerminKalenderFormContextType = ReturnType<
  typeof useUpdateTerminKalenderForm
>;

export const UpdateTerminKalenderFormContext =
  createContext<UpdateTerminKalenderFormContextType | null>(null);

export function useUpdateTerminKalenderFormContext() {
  const context = useContext(UpdateTerminKalenderFormContext);
  if (!context) throw new Error('Missing UpdateTerminKalenderFormContext');
  return context;
}
